import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddNotifications from "../AddNotifications";

const AddNotificationsDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddNotifications />
      </Box>
    </Dialog>
  );
};

export default AddNotificationsDialog;
